import { Component, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
import { logError } from "../errors/error";
import { resetError } from "../store/error-handling-actions";
import DynamicMessage from "./Popups/DynamicMessage/DynamicMessage";

const ErrorBoundaryTypes = {
    log: 1,
    log_Popup: 2,
    log_Popup_Refresh: 3,
    refresh_Back: 4,
    fatalError: 5,
}

const ErrorBoundary = ({ children }) => {
    const errorHandling = useSelector(state => state.errorHandling.error);
    const { lang, texts } = useSelector(state => state.translate);
    const [state, setState] = useState();
    const dispatch = useDispatch()
    // const navigate = useNavigate()

    useEffect(() => {
        if (errorHandling) {
            // logError(errorHandling.error, errorHandling.userMessage, errorHandling.message, errorHandling.component, errorHandling.line)
            if (errorHandling.statusCode === 502) {
                setState(<DynamicMessage
                    type={errorHandling.type}
                    title={errorHandling.showTitle && texts.Error}
                    content={texts.apiDownError}
                    confirmText={errorHandling.confirmText}
                    confirmFunc={() => { dispatch(resetError()) }}
                    showCancel={errorHandling.showCancel}
                    showRestore={errorHandling.showRestore} />)
            }
            else
                if (errorHandling.statusCode === 422) {
                    setState(<DynamicMessage
                        type={errorHandling.type}
                        title={errorHandling.showTitle && texts.Error}
                        content={texts.fileWhitening}
                        confirmText={errorHandling.confirmText}
                        confirmFunc={() => { dispatch(resetError()) }}
                        showCancel={errorHandling.showCancel}
                        showRestore={errorHandling.showRestore} />)
                }
                else
                    switch (errorHandling.level) {
                        // levels: 1 - only log, 2 - log + message popup, 3 - log + message popup + page refresh, 4 - refresh + back (not coded), 5 - fatal error
                        // 1 - only log
                        case ErrorBoundaryTypes.log:
                            dispatch(resetError())
                            break;
                        // 2 - log + message popup
                        case ErrorBoundaryTypes.log_Popup:
                            setState(<DynamicMessage
                                type={errorHandling.type}
                                title={errorHandling.showTitle && texts.Error}
                                content={errorHandling.userMessage ? errorHandling.userMessage : texts.errorOccurred}
                                confirmText={errorHandling.confirmText}
                                confirmFunc={() => { dispatch(resetError()) }}
                                showCancel={errorHandling.showCancel}
                                showRestore={errorHandling.showRestore} />)
                            break;
                        // 3 - log + message popup + page refresh
                        case ErrorBoundaryTypes.log_Popup_Refresh:
                            setState(<DynamicMessage
                                type={errorHandling.type}
                                title={errorHandling.showTitle && texts.Error}
                                content={errorHandling.userMessage ? errorHandling.userMessage : texts.errorOccurred}
                                confirmText={errorHandling.confirmText}
                                confirmFunc={() => { dispatch(resetError()); document.location.reload(true) }}
                                showCancel={errorHandling.showCancel}
                                showRestore={errorHandling.showRestore} />)
                            break;
                        // 4 - refresh + back (not coded)
                        case ErrorBoundaryTypes.refresh_Back:
                            setState(<DynamicMessage
                                type={errorHandling.type}
                                title={errorHandling.showTitle && texts.Error}
                                content={errorHandling.userMessage ? errorHandling.userMessage : texts.errorOccurred}
                                confirmFunc={() => dispatch(resetError())} />)
                            break;
                        // 5 - fatal error
                        case ErrorBoundaryTypes.fatalError:
                            setState(<div style={{ backgroundImage: 'url(https://blob.skillz-edu.org/uploadFiles/500.jpg)', height: '100vh' }}> </div>)
                            break;
                    }
        } else {
            setState(null)
        }
    }, [errorHandling])

    return <div>{state}</div>

}
export default ErrorBoundary
